"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var web_1 = require("@react-spring/web");
var react_1 = __importDefault(require("react"));
var react_use_gesture_1 = require("react-use-gesture");
var isTouchDevice = function () {
    return window.matchMedia('(pointer: coarse)').matches;
};
/**
 * https://codesandbox.io/s/react-spring-920-beta-touch-scrolling-example-5riij
 *
 * @todo test on Firefox
 */
var HorizontalScrollView = function (props) {
    var decay = 0.995;
    var ref = react_1.default.useRef(null);
    var _a = __read((0, web_1.useSpring)(function () { return ({
        x: 0,
        config: { decay: decay },
    }); }, [decay]), 2), x = _a[0].x, spring = _a[1];
    var bind = (0, react_use_gesture_1.useGesture)({
        onDrag: function (_a) {
            var down = _a.down, movement = _a.movement, vxvy = _a.vxvy;
            spring.start({
                x: -movement[0],
                immediate: down,
                config: {
                    velocity: -vxvy[0],
                },
            });
        },
        onWheelStart: function () {
            // Stop any user-land scroll animation from
            // conflicting with the browser's animation
            spring.stop();
        },
    }, {
        drag: {
            axis: 'x',
            filterTaps: true,
            initial: function () {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                return [-ref.current.scrollLeft, 0];
            },
        },
    });
    return (react_1.default.createElement(web_1.animated.div, __assign({ ref: ref, scrollLeft: x, className: props.className }, bind()), props.children));
};
var HorizontalDragScroll = function (_a) {
    var children = _a.children, className = _a.className;
    if (isTouchDevice()) {
        // just use the device's native horizontal scrolling features, as they're better than anything we can do
        return react_1.default.createElement("div", { className: className }, children);
    }
    // if we're not on a touch device, the browser won't provide a way to scroll horizontally on drag,
    // so we provide a replacement since we're hiding the scroll bar from them
    return react_1.default.createElement(HorizontalScrollView, { className: className }, children);
};
exports.default = HorizontalDragScroll;
